import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../../store/step-personal-management/step.slice";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { EmployeeApi } from '../../../api/employee/employee.api';
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useSnackbar } from "../../../components/snackbar/SnackbarCustom";
import moment from "moment";
import { saveAs } from "file-saver";
import { initial_form_personal_record, initial_form_personal_record_test } from "./initial_form_data";
import { useTranslation } from "react-i18next";
import { BACKGROUND_FILE, status_employee } from "./enum/enum-personnel";
import { PositionApi } from "../../../api/position/position.api";
import { decodeId, validateEmail } from "../../../utils/app.utils";
import { ProvinceAPI } from "../../../api/province/province.api";
import { produce } from "immer";



type personalRecordStateProps = {
    IS_PROFILE?: boolean;
}
export const PersonalRecordState = ({ IS_PROFILE }: personalRecordStateProps) => {
    const { t } = useTranslation();
    const { id: paramId } = useParams();
    const id_decode = decodeId(paramId ?? "");
    const id = id_decode ? id_decode : paramId;
    const { showSnackbar } = useSnackbar();
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const step: number = useSelector((state: any) => state?.step?.step);


    // MASTER
    const [position_data, setPosition] = useState<any[]>([]);
    const [province_data, setProVinceData] = useState<any[]>([]);

    const [originalCoverFile, setOriginalCoverFile] = useState<any>(null);
    const [notEdit, setNotEdit] = useState<boolean>(IS_PROFILE ? false : true);
    const [coverFile, setCoverFile] = useState<any>(null);
    const [formPersonalRecord, setFormPersonalRecord] = useState<any>(initial_form_personal_record);
    const initialErrorMessage = {}
    const handleTestForm = (status: boolean) => setFormPersonalRecord(status ? initial_form_personal_record_test : initial_form_personal_record);
    const [errorMessage, setErrorMessage] = useState<any>(initialErrorMessage);
    const status_accept: string[] = ['active', 'สิ้นสุดการเป็นบุคลากร']; // i18n-ignore
    const is_accept: boolean = status_accept.includes(formPersonalRecord?.status_employee);
    const handleChangeEnableEdit = (status: boolean) => setNotEdit(status);
    const handleChangeInformationSiblings = (field: string, value: any, index: number) => {
        setErrorMessage(initialErrorMessage);
        setFormPersonalRecord((prev: any) => ({
            ...prev, siblings: prev?.siblings?.filter((x: any) => x?.status === 'active').map((list: any, i: number) => {
                return i === index ? { ...list, [field]: value } : list
            })
        }))
    }
    const handleDeleteInformationSibling = (index: number) => {
        if (id) {
            setFormPersonalRecord((prev: any) => ({ ...prev, siblings: prev?.siblings?.filter((x: any) => x?.status === 'active')?.map((list: any, i: number) => i === index ? { ...list, status: "inactive" } : list) }))
        } else {
            setFormPersonalRecord((prev: any) => ({ ...prev, siblings: prev?.siblings?.filter((_: any, i: number) => i !== index) }))
        }
    }
    const handleAddInformationSibling = () => {
        const newSibling = {
            siblings_name: "",
            siblings_old: "",
            siblings_occupation: "",
            siblings_workspace: "",
            status: "active"
        }
        setFormPersonalRecord((prev: any) => ({ ...prev, siblings: [...prev?.siblings, newSibling] }))
    }

    const handleChangeFormPersonalRecord = (name: string, value: any) => {
        setErrorMessage(initialErrorMessage);
        setFormPersonalRecord((prev: any) => produce(prev, (draft: any) => {
            draft[name] = value
            // ({ ...prev, [name]: value })
        }));
    }
    const handleChangeCoverFile = (file: any) => {
        setCoverFile(file);
    }

    const handleChangeAdditionalInformation = (main_field: string, field: string, value: any, out_side?: boolean) => {
        if (out_side) {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    [main_field]: value
                }
            }))
        } else {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    [main_field]: {
                        ...prev?.additional_information?.[main_field],
                        [field]: value
                    }
                }
            }))
        }
    }
    const handleOptionLanguageAdditionalInformation = (mode: { remove?: { mainField: string, index: number }, add?: { mode: "language_proficiency" | "other_abilities" }, change?: { mainField: string, field: string, value: string, index: number } }) => {
        try {
            if (mode.remove) {
                handleRemoveLanguageAdditionalInformation(mode.remove.mainField, mode.remove.index);
            } else if (mode.change) {
                handleChangeLanguageAdditionalInformation(mode.change.mainField, mode.change.field, mode.change.value, mode.change.index);
            } else if (mode.add) {
                handleAddLanguageAdditionalInformation(mode.add.mode);
            }
        } catch (error) {
            console.log(error)
        }
    };
    const handleChangeLanguageAdditionalInformation = (mainField: string, field: string, value: any, index: number) => {
        setFormPersonalRecord((prev: any) => ({
            ...prev,
            additional_information: {
                ...prev.additional_information,
                [mainField]: prev?.additional_information?.[mainField]?.filter((x: any) => x.status === 'active').map((list: any, i: number) => {
                    return i === index ? { ...list, [field]: value } : list
                })
            }
        }))
    }
    const handleAddLanguageAdditionalInformation = (mode: "language_proficiency" | "other_abilities") => {
        const new_row_language_proficiency = {
            language_name: "",
            level_speaking: "",
            level_writing: "",
            level_reading: "",
            level_printing: "",
            status: "active"
        }
        const new_abilities = {
            abilities_name: "",
            level_abilities: "",
            status: "active"
        }
        if (mode === 'language_proficiency') {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    language_proficiency: [...prev?.additional_information?.language_proficiency, new_row_language_proficiency]
                }
            }))
        } else if (mode === 'other_abilities') {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    other_abilities: [...prev?.additional_information?.other_abilities, new_abilities]
                }
            }))
        }

    }
    const handleRemoveLanguageAdditionalInformation = (mainField: string, index: number) => {
        if (id) {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    [mainField]: prev.additional_information?.[mainField].filter((x: any) => x?.status === 'active')?.map((list: any, i: number) => i === index ? { ...list, status: "inactive" } : list)
                }
            }))
        } else {
            setFormPersonalRecord((prev: any) => ({
                ...prev,
                additional_information: {
                    ...prev.additional_information,
                    [mainField]: prev.additional_information?.[mainField].filter((_: any, i: number) => i !== index)
                }
            }))
        }
    }




    const handleChangeFormPersonalRecordParent = (name: string, value: any) => {
        setErrorMessage(initialErrorMessage);
        setFormPersonalRecord((prev: any) => {
            return {
                ...prev,
                parent_info: {
                    ...prev.parent_info,
                    [name]: value
                }
            }
        })
    }
    const handleChangeField = (column: string, name: string, value: any) => {
        setErrorMessage(initialErrorMessage);
        setFormPersonalRecord((prev: any) =>
            produce(prev, (draft: any) => {
                if (!draft[column]) {
                    draft[column] = {} as any;
                }
                draft[column][name] = value;
            })
        );
    };
    const handleChangeFieldInside = (column: string, subColumn: string, name: string, value: any) => {
        setErrorMessage(initialErrorMessage);
        setFormPersonalRecord((prev: any) => {
            return {
                ...prev,
                [column]: {
                    ...prev[column],
                    [subColumn]: {
                        ...prev[column][subColumn],
                        [name]: value
                    }
                }
            }
        })
    }
    const handleChangeSocialMediaContact = (name: string, value: string, index: number) => {
        setFormPersonalRecord((prev: any) => ({
            ...prev,
            brief_history: {
                ...prev?.brief_history,
                background_social_media_data: prev?.brief_history?.background_social_media_data?.map((list: any, i: number) => {
                    return i === index ? { ...list, [name]: value } : list
                }) || []
            }
        }))
    }
    const setSameAddressAsIdCard = (status: boolean, isRegistrationHouse?: boolean) => {
        if (status) {
            setFormPersonalRecord((prev: any) => {
                return {
                    ...prev,
                    ...(isRegistrationHouse ? {
                        address_registration_house: {
                            ...prev?.address_registration_house,
                            house_number: prev?.address_info?.house_number,
                            moo: prev?.address_info?.moo,
                            soi: prev?.address_info?.soi,
                            road: prev?.address_info?.road,
                            province: prev?.address_info?.province,
                            district: prev?.address_info?.district,
                            district_sub: prev?.address_info?.district_sub,
                            postcode: prev?.address_info?.postcode,
                        }
                    } : {
                        current_address: {
                            ...prev?.current_address,
                            house_number: prev?.address_info?.house_number,
                            moo: prev?.address_info?.moo,
                            soi: prev?.address_info?.soi,
                            road: prev?.address_info?.road,
                            province: prev?.address_info?.province,
                            district: prev?.address_info?.district,
                            district_sub: prev?.address_info?.district_sub,
                            postcode: prev?.address_info?.postcode,
                        }
                    })
                }
            })
        } else {
            setFormPersonalRecord((prev: any) => {
                return {
                    ...prev,
                    ...(isRegistrationHouse ? {
                        address_registration_house: {
                            ...prev?.address_registration_house,
                            house_number: "",
                            moo: "",
                            soi: "",
                            road: "",
                            province: "",
                            district: "",
                            district_sub: "",
                            postcode: "",
                        }
                    } : {
                        current_address: {
                            ...prev?.current_address,
                            house_number: "",
                            moo: "",
                            soi: "",
                            road: "",
                            province: "",
                            district: "",
                            district_sub: "",
                            postcode: "",
                        }
                    })
                }
            })
        }
    }
    const handleAddEducation = (objData: any) => setFormPersonalRecord((prev: any) => ({ ...prev, student_history: { ...prev?.student_history, student_history_data: [...prev?.student_history?.student_history_data, { ...objData, status: 'active' }] } }))
    const handleAddWorkHistory = (objData: any) => {
        try {
            setFormPersonalRecord((prev: any) => ({
                ...prev, work_history: { ...prev?.work_history, work_history_data: [...prev?.work_history?.work_history_data, { ...objData }] }
            }))
        } catch (error) {
            console.log(error)
        }
    }
    const handleAddTraining = (objData: any) => {
        try {
            console.log(objData)
            setFormPersonalRecord((prev: any) => ({
                ...prev, training: { ...prev?.training, training_data: [...prev?.training?.training_data, { ...objData }] }
            }))
        } catch (error) {
            console.log(error)
        }
    }
    const handleDeleteEducationByIndex = (index: number, id?: number) => {
        setFormPersonalRecord((prev: any) => {
            const filterIndex: any[] = prev?.student_history?.student_history_data?.filter((_: any, i: number) => i !== index) || [];
            const filterData: any[] = prev?.student_history?.student_history_data?.map((list: any) => {
                return list?.id_education === id ? { ...list, status: 'inactive' } : list
            }) || [];
            return {
                ...prev,
                student_history: {
                    ...prev?.student_history,
                    student_history_data: id ? filterData : filterIndex
                }
            }
        })
    }
    const handleDeleteWorkHistory = (index: number) => setFormPersonalRecord((prev: any) => ({ ...prev, work_history: { ...prev?.work_history, work_history_data: prev?.work_history?.work_history_data?.filter((_: any, i: number) => i !== index) } }))
    const handleDeleteTraining = (index: number) => setFormPersonalRecord((prev: any) => ({ ...prev, training: { ...prev?.training, training_data: prev?.training?.training_data?.filter((_: any, i: number) => i !== index) } }))
    const handleUpdateData = async (objData: any, index: number, id_data?: number, callback?: () => void) => {
        try {
            if (id) {
                dispatch(setLoading())
                const file: any = objData?.file ? objData?.file : null;
                const oldFile = objData?.oldFile?.length > 0 ? objData?.oldFile[0] : null;
                const body = {
                    ...objData,
                    id_education_type: objData?.education_level || objData?.id_education_type,
                    faculty: objData?.group,
                    certificate: objData?.education_certificate,
                    date_end_study: objData?.date_graduation,
                    date_start_study: objData?.date_admission,
                    errorMessage: undefined,
                    date_admission: undefined,
                    date_graduation: undefined,
                    education_certificate: undefined,
                    education_files: undefined,
                    education_type: undefined,
                    education_level: undefined,
                    group: undefined,
                    file: undefined,
                    oldFile: undefined
                }
                if (file) {
                    const newData: FormData = new FormData();
                    newData.append('file', file[0]);
                    await handleUploadFileEducation(objData?.id_education, newData, async () => {
                        id_data && await handleUpdateHistory(id_data, 'education', body, () => {
                            handleGetDetail(+id);
                            alertSuccess(t('อัพเดตข้อมูล'), t('อัพเดตข้อมูลเรียบร้อย'), undefined, () => {
                                callback && callback();
                            });
                        })
                    });
                } else if (!objData?.education_files) {
                    id_data && await handleUpdateHistory(id_data, 'education', body, async () => {
                        handleGetDetail(+id);
                        await handleDeleteFileEducation(oldFile?.id_education_file, 'education', () => {
                            handleGetDetail(+id);
                            alertSuccess(t('อัพเดตข้อมูล'), t('อัพเดตข้อมูลเรียบร้อย'), undefined, () => {
                                callback && callback()
                            });
                        })
                    })
                } else {
                    id_data && await handleUpdateHistory(id_data, 'education', body, () => {
                        handleGetDetail(+id);
                        alertSuccess(t('อัพเดตข้อมูล'), t('อัพเดตข้อมูลเรียบร้อย'), undefined, () => {
                            callback && callback();
                        });
                    })
                }
            } else {
                setFormPersonalRecord((prev: any) => {
                    const filterIndex: any[] = prev?.student_history?.student_history_data?.map((list: any, i: number) => {
                        return index === i ? { ...objData } : list
                    }) || [];
                    const filterData: any[] = prev?.student_history?.student_history_data?.map((list: any) => {
                        return list?.id_education === id_data ? { ...objData, } : list
                    }) || [];
                    return {
                        ...prev,
                        student_history: {
                            ...prev?.student_history,
                            student_history_data: id_data ? filterData : filterIndex
                        }
                    }
                })
                alertSuccess(t('อัพเดตข้อมูล'), t('อัพเดตข้อมูลเรียบร้อย'), undefined, () => {
                    callback && callback();
                });
            }
        } catch (error) {
            alertError(t("เกิดข้อผิดพลาดในการแก้ไขข้อมูล"))
            dispatch(unsetLoading());
            console.log(error)
        }
    }
    const handleUpdateHistoryWork = (name: string, value: any, updateTable?: { objData: any, index: number }) => {
        try {
            if (updateTable) {
                setFormPersonalRecord((prev: any) => ({
                    ...prev,
                    work_history: {
                        ...prev?.work_history,
                        work_history_data: prev?.work_history?.work_history_data?.map((list: any, i: number) => {
                            return i === updateTable?.index ? { ...updateTable?.objData } : list
                        })
                    }
                }));
            } else {
                setFormPersonalRecord((prev: any) => ({ ...prev, work_history: { ...prev?.work_history, [name]: value } }));
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleUpdateTraining = (name: string, value: any, updateTable?: { objData: any, index: number }) => {
        try {
            if (updateTable) {
                setFormPersonalRecord((prev: any) => ({
                    ...prev,
                    training: {
                        ...prev?.training,
                        training_data: prev?.training?.training_data?.map((list: any, i: number) => {
                            return i === updateTable?.index ? { ...updateTable?.objData } : list
                        })
                    }
                }));
            } else {
                setFormPersonalRecord((prev: any) => ({ ...prev, training: { ...prev?.training, [name]: value } }));
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleDeleteHistory = async (id_status: number, type: 'education' | 'training' | 'work_history', callback?: () => void) => {
        dispatch(setLoading());
        await EmployeeApi.deleteHistoryDetail(id_status, type)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_DATA"), t("PERSONAL_MANAGEMENT.NOTIFICATION.DATA_DELETED_SUCCESSFULLY"))
                }
            }).catch(() => alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_FAILED"))).finally(() => {
                dispatch(unsetLoading())
            }).finally(() => {
                id && handleGetDetail(+id);
                callback && callback();
            })
    }
    const handleUpdateHistory = async (id_status: number, type: 'education' | 'training' | 'work_history', data: any, callback?: () => void) => {
        dispatch(setLoading());
        await EmployeeApi.updateHistoryDetail(id_status, type, data)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.DATA_UPDATED_SUCCESSFULLY"))
                }
            }).catch(() => alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_FAILED"))).finally(() => {
                dispatch(unsetLoading())
            }).finally(() => {
                callback && callback();
            })
    }

    const handleUploadFileEducation = async (id_education: number, newFile: FormData, callback?: () => void) => {
        await EmployeeApi.uploadEducation(id_education, newFile)
            .then(res => {
                if (res.status < 300) {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_FILE_SUCCESS"));
                }
            }).catch(() => {

            }).finally(() => {
                callback && callback();
            })
    }
    const handleDeleteFileEducation = async (id_data: number, type: 'education' | 'training' | 'background' | 'avatar', callback?: () => void) => {
        await EmployeeApi.deleteFile(id_data, type)
            .then((res) => {
                if (res.status < 300) {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_FILE_SUCCESS"));
                }
            }).catch(() => { }).finally(() => {
                callback && callback();
            })
    }
    const handleUpdateEmployee = async (id_employee: number, data: any, callback?: () => void) => {
        dispatch(setLoading());
        await EmployeeApi.updated(id_employee, data).then((res) => {
            if (res.status < 300) {
                alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.DATA_UPDATED_SUCCESSFULLY"))
            } else {
                alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_FAILED"))
            }
        }).catch(() => {
            alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
            callback && callback();
        })
    }
    const handleUploadFileTraining = async (id_training: number, newFile: FormData, callback?: () => void) => {
        await EmployeeApi.uploadTraining(id_training, newFile)
            .then(res => {
                if (res.status < 300) {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_TRAINING_HISTORY_FILE_SUCCESS"));
                }
            }).catch(() => {

            }).finally(() => {
                callback && callback();
            })
    }



    const isValid = (mode: "check" | "validate", checkAll?: boolean): boolean => {
        const errors: Record<string, string> = {};
        // console.log(formPersonalRecord)
        if ((!formPersonalRecord?.profile && formPersonalRecord?.employee_image?.length < 1) && checkAll) {
            errors.profile = 'PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PROFILE_PICTURE'
        }
        if (!formPersonalRecord.title && checkAll) {
            errors.title = `PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_TITLE`;
        }
        if (!formPersonalRecord.title_eng && checkAll) {
            errors.title_eng = `PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_TITLE`;
        }
        if (!formPersonalRecord.first_name) {
            errors.first_name = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FIRST_NAME";
        }
        if (!formPersonalRecord.first_name_eng) {
            errors.first_name_eng = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FIRST_NAME";
        }
        if (!formPersonalRecord.last_name) {
            errors.last_name = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_LAST_NAME";
        }
        if (!formPersonalRecord.last_name_eng) {
            errors.last_name_eng = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_LAST_NAME";
        }
        if (!formPersonalRecord.buddhist_name && checkAll) {
            errors.buddhist_name = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_NICK_NAME";
        }
        if (!formPersonalRecord.buddhist_name_eng && checkAll) {
            errors.buddhist_name_eng = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_NICK_NAME";
        }
        if (!formPersonalRecord.employee_no && checkAll) {
            errors.employee_no = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_IDENTIFICATION";
        }
        if (!formPersonalRecord.phone_number && checkAll) {
            errors.phone_number = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PHONE_NUMBER";
        }
        if (!formPersonalRecord.email_personal && checkAll) {
            errors.email_personal = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PERSONAL_EMAIL";
        }
        if (!validateEmail(formPersonalRecord.email_personal) && checkAll) {
            errors.email_personal = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.EMAIL_FORMAT";
        }
        if (!formPersonalRecord.email_organization && checkAll) {
            errors.email_organization = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ORGANIZATIONAL_EMAIL";
        }
        if (!validateEmail(formPersonalRecord.email_organization) && checkAll) {
            errors.email_organization = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.EMAIL_FORMAT";
        }
        if (!formPersonalRecord.gender && checkAll) {
            errors.gender = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_GENDER";
        }
        if (!formPersonalRecord.idcard && checkAll) {
            errors.idcard = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ID_CARD_NUMBER";
        }
        if (formPersonalRecord.idcard?.length < 9 && checkAll) {
            errors.idcard = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ID_CARD_NUMBER_LENGTH";
        }
        if (!formPersonalRecord.date_issue && checkAll) {
            errors.date_issue = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ID_CARD_ISSUE_DATE";
        }
        if (!formPersonalRecord.date_expiry && checkAll) {
            errors.date_expiry = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ID_CARD_EXPIRY_DATE";
        }
        if (!formPersonalRecord.date_of_birth && checkAll) {
            errors.date_of_birth = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_BIRTHDAY";
        }
        if (!formPersonalRecord.province && checkAll) {
            errors.province = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PROVINCE";
        }
        if (!formPersonalRecord.place_of_birth && checkAll) {
            errors.place_of_birth = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PLACE_OF_BIRTH";
        }
        // if (!formPersonalRecord.weight && checkAll) {
        //     errors.weight = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_WEIGHT";
        // }
        // if (!formPersonalRecord.height && checkAll) {
        //     errors.height = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_HEIGHT";
        // }
        // if (!formPersonalRecord.blood && checkAll) {
        //     errors.blood = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_BLOOD_TYPE";
        // }
        if (!formPersonalRecord.race && checkAll) {
            errors.race = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ETHNICITY";
        }
        if (!formPersonalRecord.nationality && checkAll) {
            errors.nationality = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_NATIONALITY";
        }
        if (!formPersonalRecord.religion && checkAll) {
            errors.religion = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_RELIGION";
        }
        // if (!formPersonalRecord.occupation && checkAll) {
        //     errors.occupation = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_OCCUPATION";
        // }
        // if (!formPersonalRecord.number_of_siblings && checkAll) {
        //     errors.number_of_siblings = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_NUMBER_OF_SIBLINGS";
        // }
        if (!formPersonalRecord.date_of_ordination && checkAll) {
            errors.date_of_ordination = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ORDINATION_DATE";
        }
        if (!formPersonalRecord.receipt_number && checkAll) {
            errors.receipt_number = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_ORDINATION_CERTIFICATE_NUMBER";
        }
        if (!formPersonalRecord.church && checkAll) {
            errors.church = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_SECT";
        }
        if (!formPersonalRecord.idposition && checkAll) {
            errors.idposition = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_CURRENT_POSITION";
        }
        if (!formPersonalRecord.date_start_work && checkAll) {
            errors.date_start_work = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_START_DATE_AT_COLLEGE";
        }
        if (!formPersonalRecord.date_end_work && checkAll) {
            errors.date_end_work = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_END_DATE_AT_COLLEGE";
        }
        if (!formPersonalRecord.phone_work && checkAll) {
            errors.phone_work = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_WORK_PHONE_NUMBER";
        }
        if (!formPersonalRecord.parent_info?.father_name && checkAll) {
            errors.father_name = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FATHER_NAME";
        }
        if (!formPersonalRecord.parent_info?.father_status_alive && checkAll) {
            errors.father_status_alive = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FATHER_STATUS";
        }
        if (!formPersonalRecord.parent_info?.father_occupation && checkAll) {
            errors.father_occupation = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FATHER_OCCUPATION";
        }
        if (!formPersonalRecord.disabled_detail && formPersonalRecord.disabled === 'true' && checkAll) {
            errors.disabled_detail = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_DISABLED_DETAIL";
        }
        // if (!formPersonalRecord.parent_info?.father_income && checkAll) {
        //     errors.father_income = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_FATHER_ANNUAL_INCOME";
        // }
        if (!formPersonalRecord.parent_info?.mother_name && checkAll) {
            errors.mother_name = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_MOTHER_NAME";
        }
        if (!formPersonalRecord.parent_info?.mother_status_alive && checkAll) {
            errors.mother_status_alive = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_MOTHER_STATUS";
        }
        if (!formPersonalRecord.parent_info?.mother_occupation && checkAll) {
            errors.mother_occupation = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_MOTHER_OCCUPATION";
        }
        // if (!formPersonalRecord.parent_info?.mother_income && checkAll) {
        //     errors.mother_income = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_MOTHER_ANNUAL_INCOME";
        // }
        if (!formPersonalRecord.parent_info?.status_parent && checkAll) {
            errors.status_parent = "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE_VALIDATE.SPECIFY_PARENTS_MARITAL_STATUS";
        }
        if (!formPersonalRecord.address_info?.house_number && checkAll) {
            errors.address_info_house_number = t("ระบุบ้านเลขที่");
        }
        if (!formPersonalRecord.address_info?.province && checkAll) {
            errors.address_info_province = t("ระบุจังหวัด");
        }
        if (!formPersonalRecord.address_info?.district && checkAll) {
            errors.address_info_district = t("ระบุเขต/อำเภอ");
        }
        if (!formPersonalRecord.address_info?.district_sub && checkAll) {
            errors.address_info_district_sub = t("ระบุแขวง/ตำบล");
        }
        if (!formPersonalRecord.address_info?.postcode && checkAll) {
            errors.address_info_postcode = t("ระบุรหัสไปรษณีย์");
        }
        if (!formPersonalRecord.address_registration_house?.house_number && checkAll) {
            errors.address_registration_house_house_number = t("ระบุบ้านเลขที่");
        }
        // if (!formPersonalRecord.address_registration_house?.province && checkAll) {
        //     errors.address_registration_house_province = "ระบุจังหวัด";
        // }
        // if (!formPersonalRecord.address_registration_house?.district && checkAll) {
        //     errors.address_registration_house_district = "ระบุเขต/อำเภอ";
        // }
        // if (!formPersonalRecord.address_registration_house?.district_sub && checkAll) {
        //     errors.address_registration_house_district_sub = "ระบุแขวง/ตำบล";
        // }
        // if (!formPersonalRecord.address_registration_house?.postcode && checkAll) {
        //     errors.address_registration_house_postcode = "ระบุรหัสไปรษณีย์";
        // }
        if (!formPersonalRecord.current_address?.house_number && checkAll) {
            errors.current_address_house_number = t("ระบุบ้านเลขที่");
        }
        if (!formPersonalRecord.current_address?.province && checkAll) {
            errors.current_address_province = t("ระบุจังหวัด");
        }
        if (!formPersonalRecord.current_address?.district && checkAll) {
            errors.current_address_district = t("ระบุเขต/อำเภอ");
        }
        if (!formPersonalRecord.current_address?.district_sub && checkAll) {
            errors.current_address_district_sub = t("ระบุแขวง/ตำบล");
        }
        if (!formPersonalRecord.current_address?.postcode && checkAll) {
            errors.current_address_postcode = t("ระบุรหัสไปรษณีย์");
        }
        if (!formPersonalRecord.temple_address?.address_name && checkAll) {
            errors.temple_address_address_name = t("ระบุชื่อวัด");
        }
        if (!formPersonalRecord.temple_address?.house_number && checkAll) {
            errors.temple_address_house_number = t("ระบุบ้านเลขที่");
        }
        if (!formPersonalRecord.temple_address?.province && checkAll) {
            errors.temple_address_province = t("ระบุจังหวัด");
        }
        if (!formPersonalRecord.temple_address?.district && checkAll) {
            errors.temple_address_district = t("ระบุเขต/อำเภอ");
        }
        if (!formPersonalRecord.temple_address?.district_sub && checkAll) {
            errors.temple_address_district_sub = t("ระบุแขวง/ตำบล");
        }
        if (!formPersonalRecord.temple_address?.postcode && checkAll) {
            errors.temple_address_postcode = t("ระบุรหัสไปรษณีย์");
        }
        if (!formPersonalRecord.work_address?.address_name && checkAll) {
            errors.work_address_address_name = t("ระบุชื่อองค์กร");
        }
        if (!formPersonalRecord.work_address?.address_name_second && checkAll) {
            errors.work_address_address_name_second = t("ระบุชื่ออาคาร/ห้อง");
        }
        if (!formPersonalRecord.work_address?.house_number && checkAll) {
            errors.work_address_house_number = t("ระบุบ้านเลขที่");
        }
        if (!formPersonalRecord.work_address?.province && checkAll) {
            errors.work_address_province = t("ระบุจังหวัด");
        }
        if (!formPersonalRecord.work_address?.district && checkAll) {
            errors.work_address_district = t("ระบุเขต/อำเภอ");
        }
        if (!formPersonalRecord.work_address?.district_sub && checkAll) {
            errors.work_address_district_sub = t("ระบุแขวง/ตำบล");
        }
        if (!formPersonalRecord.work_address?.postcode && checkAll) {
            errors.work_address_postcode = t("ระบุรหัสไปรษณีย์");
        }

        if (mode === 'validate') {
            setErrorMessage(errors);
            if (Object.keys(errors).length > 0) {
                for (let list of Object.keys(errors)) {
                    if (list.includes('address_info')) {
                        dispatch(setStep(2));
                        return true;
                    }
                    if (list.includes('current_address')) {
                        dispatch(setStep(2));
                        return true;
                    }
                    if (list.includes('address_registration_house')) {
                        dispatch(setStep(2));
                        return true;
                    }
                    if (list.includes('temple_address')) {
                        dispatch(setStep(2));
                        return true;
                    }
                    if (list.includes('work_address')) {
                        dispatch(setStep(2));
                        return true;
                    }
                    else {
                        dispatch(setStep(0));
                        return true;
                    }
                }
            }
            return Object.keys(errors).length > 0;
        } else {
            return Object.keys(errors).length > 0 ? true : false
        }
    }
    const handleSubmit = async (checkAll?: boolean, saveDraft?: boolean, callback?: () => void) => {
        const validate: boolean = isValid('validate', checkAll);
        if (validate) return false;

        const formValue = generateForm();
        delete formValue?.profile;
        delete formValue?.student_history;

        const educationFiles = formPersonalRecord?.student_history?.student_history_data || [];
        const trainingFiles = formPersonalRecord?.training?.training_data || [];
        const profileFile = formPersonalRecord?.profile || null;
        const currentCoverFile = coverFile?.length > 0 ? coverFile[0] : null;
        const originalCoverFile_test = originalCoverFile?.length > 0 ? originalCoverFile[0] : null;

        dispatch(setLoading());
        try {
            // let id_employee: number | undefined;
            let education_data: any[] = [];
            let training_data: any[] = [];
            if (step === 8) {
                if (id) {
                    const res = await EmployeeApi.updated(+id, { ...formValue, status_employee: status_employee.ACTIVE });
                    if (res.status > 300) return alertError('Failed to update employee');
                    education_data = res.data?.data?.education || []
                    training_data = res.data?.data?.training?.training_data || []
                    // id_employee = res.data?.data?.id_employee;
                    if (res.data?.data?.id_employee) {
                        const uploadPromises: Promise<any>[] = [
                            ...uploadEducationFiles(educationFiles, education_data),
                            ...uploadTrainingFiles(trainingFiles, training_data),
                            ...(currentCoverFile && currentCoverFile !== originalCoverFile ? [uploadBackground(res.data?.data?.id_employee, currentCoverFile)] : []),
                            ...(profileFile ? [uploadProfileFile(res.data?.data?.id_employee, profileFile)] : [])
                        ];

                        await Promise.all(uploadPromises);
                        alertSuccess(
                            t("PERSONAL_MANAGEMENT.NOTIFICATION.ADD_PERSONNEL"),
                            t("PERSONAL_MANAGEMENT.NOTIFICATION.ADD_PERSONNEL_SUCCESS"),
                            undefined,
                            () => navigate(routeName.cms.PersonnelManagement)
                        );
                    } else {
                        // alertError('Failed to get employee ID after creation.');
                    }
                } else {
                    const res = await EmployeeApi.create({ ...formValue, status_employee: status_employee.ACTIVE });
                    if (res.status > 300) return alertError('Failed to create employee');
                    education_data = res.data?.data?.education || []
                    training_data = res.data?.data?.training?.training_data || []
                    // res.data?.data?.id_employee;
                    if (res.data?.data?.id_employee) {
                        const uploadPromises: Promise<any>[] = [
                            ...uploadEducationFiles(educationFiles, education_data),
                            ...uploadTrainingFiles(trainingFiles, training_data),
                            ...(currentCoverFile && currentCoverFile !== originalCoverFile ? [uploadBackground(res.data?.data?.id_employee, currentCoverFile)] : []),
                            ...(profileFile ? [uploadProfileFile(res.data?.data?.id_employee, profileFile)] : [])
                        ];

                        await Promise.all(uploadPromises);
                        alertSuccess(
                            t("PERSONAL_MANAGEMENT.NOTIFICATION.ADD_PERSONNEL"),
                            t("PERSONAL_MANAGEMENT.NOTIFICATION.ADD_PERSONNEL_SUCCESS"),
                            undefined,
                            () => navigate(routeName.cms.PersonnelManagement)
                        );
                    } else {
                        // alertError('Failed to get employee ID after creation.');
                    }
                }
            } else if (saveDraft) {
                let education_data: any[] = [];
                let training_data: any[] = [];
                if (id) {
                    await Promise.all([
                        ...uploadEducationFiles(educationFiles, education_data),
                        ...uploadTrainingFiles(trainingFiles, training_data),
                        ...(currentCoverFile && currentCoverFile !== originalCoverFile ? [uploadBackground(+id, currentCoverFile)] : []),
                        ...(profileFile ? [uploadProfileFile(+id, profileFile)] : [])
                    ]);

                    await EmployeeApi.updated(+id, formValue);
                    alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.SAVE_DRAFT_SUCCESS"));
                } else {
                    const response = await EmployeeApi.create(formValue);
                    if (response.status >= 300) return alertError('Failed to create employee');
                    education_data = response.data?.data?.education || []
                    training_data = response.data?.data?.training?.training_data || []
                    const newId = response.data.data?.id_employee;
                    await Promise.all([
                        ...uploadEducationFiles(educationFiles, education_data),
                        ...uploadTrainingFiles(trainingFiles, training_data),
                        ...(currentCoverFile && currentCoverFile !== originalCoverFile ? [uploadBackground(newId, currentCoverFile)] : []),
                        ...(profileFile ? [uploadProfileFile(newId, profileFile)] : [])
                    ]);

                    alertSuccess(
                        t("PERSONAL_MANAGEMENT.NOTIFICATION.SAVE_DRAFT_SUCCESS"),
                        undefined,
                        undefined,
                        () => window.location.replace(routeName.cms.PersonnelManagement + `-detail/${newId}`)
                    );
                }
            } else if (id && is_accept) {
                if (currentCoverFile && currentCoverFile !== originalCoverFile_test) {
                    await uploadBackground(+id, currentCoverFile);
                }
                if (profileFile) {
                    await uploadProfileFile(+id, profileFile);
                }

                await EmployeeApi.updated(+id, formValue);
                alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPDATE_DATA_SUCCESS"), t("PERSONAL_MANAGEMENT.NOTIFICATION.DATA_UPDATED_SUCCESSFULLY"));
                callback && callback();
                handleGetDetail(+id);
            } else {
                dispatch(setStep(step + 1));
            }
        } catch (error: any) {
            alertError(error?.response?.data?.message || t("PERSONAL_MANAGEMENT.NOTIFICATION.ERROR"));
        } finally {
            dispatch(unsetLoading());
            handleChangeEnableEdit(true);
        }
    };


    function uploadEducationFiles(educationFiles: any[], education_data: any[]): Promise<any>[] {
        return educationFiles
            .filter(file => file?.file)
            .map((file, index: number) => {
                const formData = new FormData();
                formData.append('file', file?.file[0]);
                return EmployeeApi.uploadEducation(education_data ? education_data[index]?.id_education : file?.id_education, formData)
                    .then(res => {
                        if (res.status < 300) {
                            showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_EDUCATION_HISTORY_FILE_SUCCESS"));
                        } else {
                            showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_EDUCATION_HISTORY_FILE_FAILED"));
                        }
                    })
                    .catch(error => console.error('Error uploading education file', error));
            });
    }
    function uploadTrainingFiles(trainingFiles: any[], training_data: any[]): Promise<any>[] {
        return trainingFiles
            .filter(file => file?.trainingFiles)
            .map((file, index) => {
                const formData = new FormData();
                formData.append('file', file?.trainingFiles[0]);
                return EmployeeApi.uploadTraining(training_data ? training_data[index]?.id_training : file?.id_training, formData)
                    .then(res => {
                        if (res.status < 300) {
                            showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_TRAINING_HISTORY_FILE_SUCCESS"));
                        } else {
                            showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_TRAINING_HISTORY_FILE_FAILED"));
                        }
                    })
                    .catch(error => console.error('Error uploading training file', error));
            });
    }
    function uploadBackground(id_employee: number, coverFile: any): Promise<any> {
        const formData = new FormData();
        formData.append('file', coverFile);
        return EmployeeApi.uploadBackground(id_employee, formData)
            .then(res => {
                if (res.status < 300) {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_BACKGROUND_IMAGE_SUCCESS"));
                } else {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_BACKGROUND_IMAGE_FAILED"));
                }
            })
            .catch(error => console.error('Error uploading background file', error));
    }
    function uploadProfileFile(id_employee: number, profileFile: any): Promise<any> {
        const formData = new FormData();
        formData.append('file', profileFile);
        return EmployeeApi.uploadEmployee(id_employee, formData)
            .then(res => {
                if (res.status < 300) {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_PROFILE_PICTURE_SUCCESS"));
                } else {
                    showSnackbar(t("PERSONAL_MANAGEMENT.NOTIFICATION.UPLOAD_PROFILE_PICTURE_FAILED"));
                }
            })
            .catch(error => console.error('Error uploading profile file', error));
    }
    const generateForm = (undefined_key?: string[]): any => {
        const formValue = {
            ...formPersonalRecord,
            employee_work_salary: formPersonalRecord?.employee_work_salary ? +formPersonalRecord?.employee_work_salary : 0,
            // start_date: formPersonalRecord?.date_start_work ? moment(formPersonalRecord?.date_start_work)?.format("YYYY-MM-DD") : null,
            parent_info: {
                ...formPersonalRecord?.parent_info,
                is_publish: formPersonalRecord?.parent_info?.is_publish ? 1 : 0,
            },
            address_info: {
                ...formPersonalRecord?.address_info,
                id_employee: formPersonalRecord?.id_employee,
                is_publish: formPersonalRecord?.address_info?.is_publish ? 1 : 0,
            },
            address_registration_house: {
                ...formPersonalRecord?.address_registration_house,
                is_address_idcard: formPersonalRecord?.address_registration_house?.is_address_idcard ? 1 : 0,
            },
            current_address: {
                ...formPersonalRecord?.current_address,
                is_address_idcard: formPersonalRecord?.current_address?.is_address_idcard ? 1 : 0,
            },
            temple_address: {
                ...formPersonalRecord?.temple_address,
            },
            work_address: {
                ...formPersonalRecord?.work_address,
            },
            additional_information: {
                ...formPersonalRecord?.additional_information
            },
            education: {
                is_publish: formPersonalRecord?.student_history?.is_publish,
                education_data: formPersonalRecord?.student_history?.student_history_data?.map((list: any) => {
                    return {
                        id_employee: list?.id_employee,
                        id_education: list?.id_education,
                        certificate: list?.education_certificate,
                        faculty: list?.group,
                        major: list?.major,
                        minor: list?.minor,
                        branch: list?.branch,
                        educational_institutions: list?.educational_institutions,
                        id_education_type: 1,
                        date_start_study: list?.date_admission ? moment(list?.date_admission).format("YYYY-MM-DD") : null,
                        date_end_study: list?.date_graduation ? moment(list?.date_graduation).format("YYYY-MM-DD") : null,
                        status: list?.status ? list?.status : 'active'
                    }
                })
            },
            work_history: {
                id_work: formPersonalRecord?.work_history?.id_work,
                is_publish: formPersonalRecord?.work_history?.is_publish,
                idposition: undefined,// รอแก้ api
                id_position_next_first: formPersonalRecord?.work_history?.id_position_next_first || null, //เป็น string
                id_position_next_secon: formPersonalRecord?.work_history?.id_position_next_secon || null, //รอเปลี่ยนเป็น string
                duration_position_next_secon: +formPersonalRecord?.work_history?.duration_position_next_secon || null,
                duration_position_next_first: +formPersonalRecord?.work_history?.duration_position_next_first || null,
                // duration:"", รอเพิ่ม api
                work_history_data: formPersonalRecord?.work_history?.work_history_data?.map((list: any) => {
                    return {
                        ...list,
                        date_start_work: list?.date_start_work ? moment(list?.date_start_work).format("YYYY-MM-DD") : null,
                        date_end_work: list?.date_end_work ? moment(list?.date_end_work).format("YYYY-MM-DD") : null,
                        is_publish: 1
                    }
                }) || []
            },
            training: {
                ...formPersonalRecord?.training,
                training_data: formPersonalRecord?.training?.training_data?.map((list: any) => {
                    return {
                        ...list,
                        is_publish: list?.is_publish ? 1 : 0
                    }
                })
            },
            brief_history: formPersonalRecord?.brief_history,
            article: formPersonalRecord?.article

        }
        if (undefined_key) {
            undefined_key.forEach(key => {
                formValue[key] = undefined;
            });
        }

        // delete formValue?.profile;
        delete formValue?.address;
        delete formValue?.is_profile;
        // delete formValue?.student_history;
        return formValue
    }

    const getFile = async (id_file: number, fileType: string) => {
        try {
            const res = await EmployeeApi.downloadFile(id_file, 'background');
            const blobFile = new Blob([res?.data], { type: fileType })
            setOriginalCoverFile([blobFile]);
            setCoverFile([blobFile]);
        } catch (err) {
            console.log(err)
        }
    }

    // GET
    const handleGetPosition = async () => {
        let query = {
            limit: 100000,
            page: 1
        }
        await PositionApi.list(query).then((res) => {
            if (res.status < 300) {
                setPosition(res.data?.data?.items || []);
            }
        })
    }
    const handleGetProvince = async () => {
        await ProvinceAPI.GetProvince().then(res => {
            if (res.status < 300) {
                setProVinceData(res.data?.data || [])
            } else {
                setProVinceData([]);
            }
        }).catch((error) => console.log(error))
    }
    const handleGetDetail = async (id_employee: number) => {
        dispatch(setLoading());
        await EmployeeApi.getOne(id_employee).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                // console.log(data, 'data')
                if (data?.brief_history?.background_data?.background_file?.length > 0) {
                    const cover_file: any[] = data?.brief_history?.background_data?.background_file;
                    const find_cover_image = cover_file?.find((x) => x?.background_type == BACKGROUND_FILE.COVER_IMAGE);

                    if (find_cover_image) {
                        // const lastIndex: number = data?.brief_history?.background_data?.background_file?.length > 0 ? data?.brief_history?.background_data?.background_file?.length - 1 : 0;
                        getFile(find_cover_image?.id_background_file, find_cover_image?.file_type)
                    }
                }
                setFormPersonalRecord((prev: any) => ({
                    ...prev,
                    ...data,
                    is_profile: data?.employee_image?.length > 0 ? true : false,
                    // start_date: moment(data?.start_date).format('YYYY-MM-DD') || null,
                    address_info: {
                        ...(data?.address && data?.address?.length > 0 && data?.address[0]),
                        // is_publish: !!data?.address[0]?.is_publish
                    },
                    current_address: {
                        ...(data?.address?.length > 1 ? data.address?.find((x: any) => x?.id_address_type === 2) : {}),
                        is_address_idcard: !!data?.address?.find((x: any) => x?.id_address_type === 2)?.is_address_idcard
                    },
                    temple_address: {
                        ...(data?.address && data?.address?.find((x: any) => x?.id_address_type === 3))
                    },
                    work_address: {
                        ...(data?.address && data?.address?.find((x: any) => x?.id_address_type === 4))
                    },
                    address_registration_house: {
                        ...(data?.address && data?.address?.find((x: any) => x?.id_address_type === 5))
                    },
                    student_history: {
                        is_publish: data?.education?.is_publish ? true : false,
                        student_history_data: data?.education?.education_data?.length > 0 ? data?.education?.education_data?.map((list: any) => {
                            return {
                                ...list,
                                status: list?.status ? list?.status : 'active',
                                education_level: list?.education_type?.id_education_type || null,
                                education_certificate: list?.certificate,
                                group: list?.faculty,
                                date_admission: list?.date_start_study,
                                date_graduation: list?.date_end_study
                            }
                        }) : []
                    },
                    brief_history: {
                        ...data?.brief_history,
                        background_social_media_data: data?.brief_history?.background_social_media_data?.length > 0 ? data?.brief_history?.background_social_media_data?.map((list: any, index: number) => {
                            const icons: string[] = ['facebook', 'instagram', 'x', 'youtube'];
                            return {
                                ...list,
                                type: icons[index]
                            }
                        }) : ['facebook', 'instagram', 'x', 'youtube'].map((x) => {
                            return { type: x, background_social_media_link: "" }
                        })
                    }
                }))
            }
        }).catch((error) => {
            // throw new Error('Response error from server', error);
        }).finally(() => {
            setTimeout(() => {
                dispatch(unsetLoading());
            }, 400)
        })
    }

    const handleDeleteAccount = async () => {
        if (id) {
            alertActive(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_PERSONNEL"), t("PERSONAL_MANAGEMENT.NOTIFICATION.CONFIRM_DELETE_PERSONNEL"), undefined, undefined, async () => {
                dispatch(setLoading());
                await EmployeeApi.deleteEmployee(+id)
                    .then((res) => {
                        if (res.status < 300) {
                            alertSuccess(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_PERSONNEL_SUCCESS"), undefined, undefined, () => {
                                navigate(routeName.cms.PersonnelManagement)
                            })
                        }
                    }).catch(() => {
                        alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.DELETE_PERSONNEL_FAILED"));
                    }).finally(() => {
                        dispatch(unsetLoading());
                    })

            })
        }
        return;
    }
    const handleDownloadFile = async (id_file: number, file_name: string, type: 'education' | 'avatar' | 'background' | 'training') => {
        dispatch(setLoading());
        await EmployeeApi.downloadFile(id_file, type)
            .then(res => {
                if (res.status === 200) {
                    const data = res.data;
                    let fileType;
                    let fileExtension;
                    const contentType = res.headers["content-type"];
                    switch (contentType) {
                        case "application/pdf":
                            fileType = "application/pdf";
                            fileExtension = ".pdf";
                            break;
                        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                            fileType =
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                            fileExtension = ".docx";
                            break;
                        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                            fileType =
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                            fileExtension = ".xlsx";
                            break;
                        default:
                            throw new Error("Unsupported file type");
                    }
                    dispatch(unsetLoading())
                    const blob = new Blob([data], { type: fileType });
                    saveAs(blob, file_name);
                }
            }).catch((error) => {
                dispatch(unsetLoading());
                console.log(error);
                alertError(t("PERSONAL_MANAGEMENT.NOTIFICATION.DOWNLOAD_ERROR"));
            })
    }

    const handleGetAllData = async () => {
        await handleGetPosition();
        await handleGetProvince();
        if (id) {
            handleGetDetail(+id);
        }
    }

    useEffect(() => {
        handleGetAllData();
    }, [])


    console.log(formPersonalRecord?.brief_history,'formPersonalRecord?.brief_history')

    return {
        handleTestForm,
        formPersonalRecord,
        formParent: formPersonalRecord?.parent_info,
        formAddress: formPersonalRecord?.address_info,
        formCurrentAddress: formPersonalRecord?.current_address,
        formTempleAddress: formPersonalRecord?.temple_address,
        formWorkAddress: formPersonalRecord?.work_address,
        formStudentHistory: formPersonalRecord?.student_history || [],
        formWorkHistory: formPersonalRecord?.work_history,
        formTraining: formPersonalRecord?.training,
        formBiography: formPersonalRecord?.brief_history,
        formArticle: formPersonalRecord?.article,
        formAdditionalInformation: formPersonalRecord?.additional_information,
        formRegistrationHouse: formPersonalRecord?.address_registration_house,
        informationSiblings: formPersonalRecord?.siblings,
        position_data: position_data,
        province_data: province_data,
        handleChangeInformationSiblings,
        handleDeleteInformationSibling,
        handleAddInformationSibling,
        handleChangeField,
        handleChangeFieldInside,
        handleAddEducation,
        setFormPersonalRecord,
        handleChangeFormPersonalRecord,
        handleUpdateHistoryWork,
        handleAddWorkHistory,
        handleAddTraining,
        handleUpdateTraining,
        handleDeleteWorkHistory,
        handleChangeFormPersonalRecordParent,
        handleChangeSocialMediaContact,
        handleDeleteEducationByIndex,
        handleDeleteTraining,
        handleUpdateData,
        setSameAddressAsIdCard,
        errorMessage,
        isValid,
        handleSubmit,
        handleChangeEnableEdit,
        notEdit,
        handleDeleteAccount,
        handleGetDetail,
        handleDeleteHistory,
        handleUpdateHistory,
        handleUpdateEmployee,
        handleChangeCoverFile,
        coverFile,
        handleDownloadFile,
        handleUploadFileTraining,
        handleDeleteFileEducation,
        handleOptionLanguageAdditionalInformation,
        handleChangeAdditionalInformation
    }
}